module.exports = __webpack_public_path__ + "static/61oweuvxyrl._ss500_-4b5631d612f1b6c6e004046ecd0a9c99.jpg";